import React from "react";
import NotificationsForm from "./NotificationsForm.js";
import NotificationPreview from "./NotificationPreview.js";
import Style from "../../styles/js/StyleNotifications.js";
import Helper from "./Helper.js";
import { isEmptyString, isValidURL } from "../../utils/StringUtils.js";
import { notificationsErrors } from "../../consts/ErrorMessages.js";
import * as Constants from "../../consts/Constants.js";
import Axios from "axios";
import Alert from "../../components/common/SnackAlert.js";

export default function Notifications() {
  const [state, setState] = React.useState({
    title: "",
    body: "",
    image: null,
    category: "",
    subcategory: "",
    alert: false,
    link: "",
    disabled: false,
  });

  const [errors, setErrors] = React.useState([]);

  const [alertOpen, setAlertOpen] = React.useState(false);

  const setInitialState = () => {
    setState({
      category: "",
      subcategory: "",
      alert: false,
      title: "",
      body: "",
      link: "",
      image: null,
      disabled: false,
    });
    setErrors([]);
  };

  const handleSubmit = () => {
    if (validateForm()) {
      setState({ ...state, disabled: true });
      let request = Helper.parseToServer(state);
      Axios.post(Constants.FINAL_URL_NOTICES + "requests", request)
        .then((response) => {
          if (response.status === Constants.RESPONSE_OK) {
            setInitialState();
            setAlertOpen(true);
          } else {
            let errors = [];
            errors.push(notificationsErrors.server);
            setErrors(errors);
            setState({ ...state, disabled: false });
          }
        })
        .catch((error) => {
          let errors = [];
          errors.push(notificationsErrors.server);
          setErrors(errors);
          setState({ ...state, disabled: false });
        });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "alert") {
      setState({ ...state, [name]: !state.alert });
    } else if (name === "image")
      setState({
        ...state,
        [name]: {
          name: e.target.files[0].name,
          type: e.target.files[0].type,
          image: URL.createObjectURL(e.target.files[0]),
          size: e.target.files[0].size,
        },
      });
    else if (name === "category") {
      setState({ ...state, category: value, subcategory: -1 });
    } else setState({ ...state, [name]: value });
  };

  const validateForm = () => {
    let errors = [];
    if (isEmptyString(state.title)) errors.push(notificationsErrors.title);
    if (isEmptyString(state.body)) errors.push(notificationsErrors.body);
    if (isEmptyString(state.category))
      errors.push(notificationsErrors.category);
    if (state.image !== null) {
      if (state.image.size > Constants.MAX_SIZE_IMAGE_BYTES)
        errors.push(notificationsErrors.image);
    }
    if (!isEmptyString(state.link)) {
      if (!isValidURL(state.link)) errors.push(notificationsErrors.link);
    }
    setErrors(errors);
    return errors.length === 0;
  };

  const style = Style();

  return (
    <div className={style.notifications}>
      <NotificationsForm
        state={state}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        setInitialState={setInitialState}
        setState={setState}
        disabled={state.disabled}
        errors={errors}
      />
      <NotificationPreview state={state} />
      <Alert
        open={alertOpen}
        setOpen={setAlertOpen}
        mensaje={notificationsErrors.ok}
        severity="success"
      ></Alert>
    </div>
  );
}
